
import React, { RefObject } from 'react';

import { connect } from 'react-redux';
import { FormInstance } from 'antd/lib/form';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';

import { RootState } from '@share/utils';
import { insuranceActions, InsuranceSelection, IReviewBookState, setCard } from '@store/slices';
import { ICardBooking } from '@common-types';
import { PaymentMethodBase } from '@components';
import { NULL_VALUE } from '@constants';
import { ILoginState, IMenuState } from '@share/store/slices';

import './style.scss';

interface IMapStateToProps {
  reviewBookStore: IReviewBookState;
  menuStore: IMenuState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  setCard: (card: ICardBooking | null) => void;
  setSelection: (selection: InsuranceSelection) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, WrappedComponentProps {
  formRef: RefObject<FormInstance>;
  isRequired: boolean;
  display: boolean;

  onChangeCountryState: () => void;

  handlePaymentFormValidation?: (paymentForm: boolean) => void
  multiplePayments?: any;
  setPaymentSelected?: (payment: string) => void;
  paymentSelected?: string;
  scrollToPaymentSelect?: boolean;
  scrollToPaymentSelectDisabled?: () => void;
  availableNewFlow?: boolean | undefined;
  handleBillingFormValidation: (billingForm: boolean) => void;
  billingRef: RefObject<FormInstance>;
}

interface IState {
  refreshPayment: boolean;
}

class PaymentMethodComponent extends React.Component<IProps, IState> {
  state: IState = { refreshPayment: false };

  handleCardSelect = async (selectedCard: any) => {
    const { setCard, setSelection } = this.props;
    await setCard(selectedCard);
    this.setState({ refreshPayment: true });
    setSelection(NULL_VALUE);
  }

  render(): React.ReactNode {
    const { isRequired, formRef, display, reviewBookStore, loginStore, menuStore, setCard, onChangeCountryState,
      multiplePayments, setPaymentSelected, paymentSelected, handlePaymentFormValidation, scrollToPaymentSelect, scrollToPaymentSelectDisabled } = this.props;
    const { refreshPayment } = this.state;
    const { card, errorsField, loadingBooking } = reviewBookStore;
    const { account } = loginStore;
    const { items } = menuStore;

    return (
      <div>

        <div className="card shadow">
          <div className="card-header border-bottom p-4">
            <h4 className="card-title mb-0">
              <i className="bi bi-wallet me-2"></i><FormattedMessage id="review.booking.payment.options.title" />
            </h4>
          </div>

          <div className="card-body p-4 pb-0">

              <PaymentMethodBase
                form={NULL_VALUE}
                formRef={formRef}
                display={display}
                isRequired={isRequired}
                useFormLabel={true}

                refreshData={refreshPayment}
                onDataRefreshed={() => this.setState({ refreshPayment: false })}
                onChangeCountryState={onChangeCountryState}

                card={card as any}
                errorsField={errorsField}
                loading={loadingBooking}
                setCard={(card) => setCard(card)}

                displaySave={account?.isPrivateTokenAccountType || account?.isPrivateLoginAccountType}

                disableInsurance={!account?.enableInsurance || items?.isRemoveInsurance}
                multiplePayments={multiplePayments}
                setPaymentSelected={setPaymentSelected}
                paymentSelected={paymentSelected}
                handlePaymentFormValidation={handlePaymentFormValidation}
                handleCardSelect={this.handleCardSelect}
                scrollToPaymentSelect={scrollToPaymentSelect}
                scrollToPaymentSelectDisabled={scrollToPaymentSelectDisabled}
                availableNewFlow={true}
                isCars={false}
              />

          </div>
        </div>

      </div>);
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reviewBookStore: state.reviewBookStore,
    menuStore: state.navigationMenuStore,
    loginStore: state.loginStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  setCard,
  setSelection: insuranceActions.setSelection,
};

export const PaymentMethod = connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(PaymentMethodComponent));
